module.exports = __webpack_public_path__ + "img/face.adb2e97.svg";